var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamacionAmarillo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F2B80C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9997 40.3333C24.0247 40.3333 25.6663 38.6917 25.6663 36.6667C25.6663 34.6416 24.0247 33 21.9997 33C19.9746 33 18.333 34.6416 18.333 36.6667C18.333 38.6917 19.9746 40.3333 21.9997 40.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.845 7.33346C26.0742 8.25004 24.9924 14.0937 24.9924 18.9924C24.9924 23.5757 24.9917 27.3381 24.9924 27.5098L24.9925 27.5166C24.9922 29.2361 23.5982 30.6303 21.8788 30.6305C20.1594 30.6307 18.7657 29.237 18.7659 27.5175C18.7663 24.5388 18.7659 22.2294 18.7659 18.9924C18.7659 15.8696 17.2148 8.47484 17.5956 7.33346C18.7136 3.98214 24.9281 3.66671 25.845 7.33346Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamacionAmarillo);
export default __webpack_public_path__ + "static/media/exclamacion_amarillo.112aab20cfff8fdf9282937dda9205f1.svg";
export { ForwardRef as ReactComponent };